<template>
  <div>
    <div v-if="price > 0" class="text-2xl lg:text-3xl font-bold text-primary-600 mb-4">
      £{{ price }}
    </div>
    <div v-if="item.type ==='recursive'">
      <div v-if="item.groups.length > 0">
        <div v-if="selectedGroup && selectedGroup.live_sessions && selectedGroup.live_sessions.length > 0" :key="`${selectedGroup.id}group`" class="mb-8">
          <div class="grid sm:grid-cols-2 gap-8">
            <div>
                <div>
                  Starting: <strong>{{ selectedGroup.start_date | moment('timezone', 'Europe/London', "Do MMM - HH:mm") }}</strong>
                </div>
                <div>
                  Location: <strong>{{ selectedGroup.location ? selectedGroup.location.city : 'Online' }}</strong>
                </div>
                <div>&nbsp;</div>
                <div>
                  <span @click="$refs['ses-'+selectedGroup.id].show()" class="cursor-pointer inline-block text-primary-500 hover:text-primary-600 transition-colors group relative">
                    <span class="inline-flex items-center py-0.5">
                      <span class="mr-2">See group sessions</span>
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                    </span>
                    <span class="block border-b border-primary-500 w-full group-hover:w-4 transition-all absolute bottom-0 right-0"></span>
                  </span>
                </div>
              </div>
              <div v-if="selectedGroup.location">
                <div>
                  <p class="whitespace-pre">{{  selectedGroup.location.address }}</p>
                  <a v-if="selectedGroup.location.map_link" :href="selectedGroup.location.map_link" target="_blank" rel="nofollow noreferrer noopener" class="cursor-pointer inline-block text-primary-500 hover:text-primary-600 transition-colors group relative">
                    <span class="inline-flex items-center py-0.5">
                      <span class="mr-2">Get directions</span>
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </span>
                    <span class="block border-b border-primary-500 w-full group-hover:w-4 transition-all absolute bottom-0 right-0"></span>
                  </a>
                </div>
              </div>
            </div>

              <bc-modal :ref="`ses-${selectedGroup.id}`" header="Live Sessions">
                <div class="p-4 lg:p-8">

                  <table class="w-full">
                    <thead class="opacity-50 uppercase text-xs">
                      <tr class="text-left">
                        <th></th>
                        <th>Date</th>
                        <th>Weekday</th>
                        <th class="text-right">Time</th>
                      </tr>
                    </thead>
                    <tbody class="text-sm">
                      <tr v-for="(session, index) in selectedGroup.live_sessions" :key="index" class="border-t dark:border-gray-800">
                        <td class="py-1">{{ index+1 }}</td>
                        <td class="py-1 font-bold">
                          {{ session.date | moment('timezone', 'Europe/London', "Do MMM") }}
                        </td>
                        <td class="py-1">
                          {{ session.date | moment('timezone', 'Europe/London', 'dddd') }}
                        </td>
                        <td class="py-1 text-right">
                          {{ session.date | moment('timezone', 'Europe/London', 'HH:mm')}}
                          -
                          {{ $moment(session.date).add($moment.duration(session.duration, 'minutes')) | moment('timezone', 'Europe/London', 'HH:mm') }}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </bc-modal>
        </div>

        <div v-if="item.groups.length > 1" class="label">Available live groups</div>
        <ul class="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-3 xl:grid-cols-4 gap-2 mb-4">
          <li v-for="group in item.groups">
            <label
              class="relative block px-2 py-1 rounded border shadow-sm dark:border-gray-700 cursor-pointer group hover:bg-primary-50 dark:hover:bg-primary-800 hover:border-primary-500 dark:hover:border-primary-500 transition"
              :class="{ 'bg-primary-50 dark:bg-primary-900 border-primary-700 dark:border-primary-400' : selectedGroup === group }"
            >
              <input class="hidden" type="radio" @change="setGroup(group)" name="group" :value="group.id" />
              <div>
                <span class="block text-sm text-primary-600">{{ group.location ? group.location.city : 'Online' }}</span>
                <span class="block font-bold">{{ group.start_date | moment('timezone', 'Europe/London', "Do MMM") }}</span>
                <span class="block text-sm">{{ group.start_date | moment('timezone', 'Europe/London', "HH:mm") }}</span>

              </div>
              <span v-if="selectedGroup === group" class="flex items-center justify-center h-5 w-5 rounded-full bg-primary-200 dark:bg-primary-800 absolute right-2 top-2">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-primary-700 dark:text-primary-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                </svg>
              </span>
            </label>
          </li>
        </ul>
        <div v-if="item.type ==='recursive' && selectedGroup && selectedGroup.stock === 0" class="flex mb-8 block border-l-2 border-primary-100 pl-4 ">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <p>
            Sorry there are no places available for selected group.
            <span class="hidden">Please select other group or <strong>join waiting list</strong>.</span>
          </p>
        </div>

      </div>
      <div v-else class="flex mb-8 block border-l-2 border-primary-100 pl-4">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <p>
          Sorry there are no classes available to book at this time.
          Please check back later <span>or <strong>register your interest</strong></span>.
        </p>
      </div>
    </div>

    <bc-button
        v-if="item.type ==='recursive' && selectedGroup && selectedGroup.stock === 0"
        variant="primary"
        :disabled="loading"
        @click.prevent="joinWaitingList()"
      >
      <span>
        Join Waiting List
      </span>
    </bc-button>

    <bc-button
        v-else
        variant="primary"
        @click.prevent="cartAdd()"
        :disabled="item.type ==='recursive' && !selectedGroup"
      >
      <span>
        {{  item.type === 'simple' ? 'Buy Now' : 'Book Now' }}
      </span>
    </bc-button>

    <bc-button
      v-if="item.type ==='recursive'"
      variant="primary"
      @click.prevent="registerInterest()"
    >
      <span>
        Register your interest
      </span>
    </bc-button>
  </div>
</template>
<script>
export default {
  name: 'AppAddToCart',
  props: {
    product: {
      type: [Object,String],
      required: true
    },
    quantity: {
      type: Number,
      default: 1,
      required: true
    },
    group: {
      type: Number,
      required: false
    },
    auth:{
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      selectedGroup: null,
      select: false,
      price: 0,
      loading: false
    }
  },
  computed: {
    item() {
      return JSON.parse(this.product)
    }
  },
  mounted() {
    if (this.item.groups.length > 0 && !this.selectedGroup) {
      if(this.group) {
        this.selectedGroup = this.item.groups.find(x => x.id === this.group)
        this.price = this.selectedGroup.price
      }else{
        this.selectedGroup = this.item.groups[0]
        this.price = this.selectedGroup.price
      }
    }else{
      this.price = this.item.price
    }
  },
  methods: {
    setGroup (group) {
      this.selectedGroup = group
      this.select = false
      this.price = group.price
    },
    registerInterest() {
      if(this.auth) {
        this.$modal.show('register-interest')
      }else{

        this.$dialog.confirm({
          title: 'Register Interest',
          text: 'You must be logged in to register your interest.',
          okButtonText: 'Login'
          // variant: 'my-confirm',
          // ...More props
        }).then((result) => {
          if (result.isOk) {
            window.location = '/login'
          }
        })

      }
    },
    joinWaitingList() {
      if(this.auth) {
        this.$dialog.confirm({
          title: 'Join Waiting List',
          text: 'We will add you to the waiting list. If a space becomes available you will receive an email.',
          okButtonText: 'OK, Join Now'
          // variant: 'my-confirm',
          // ...More props
        }).then((result) => {
          if (result.isOk) {
            this.loading = true
            axios.post('/api/groups/'+ this.selectedGroup.id +'/waiting')
              .then((response) => {

                this.$dialog.alert({
                  title: response.data.title,
                  text: response.data.message,
                  okButtonText: 'OK'
                })

              })
              .catch((err) => {
                  this.$dialog.alert({
                    title: err.response.data.title,
                    text: err.response.data.message,
                    okButtonText: 'OK'
                  })
              })
              .then(() => {
                this.loading = false
              })
          }
        })
      }else{

        this.$dialog.confirm({
          title: 'Join Waiting List',
          text: 'You must be logged in to join the waiting list.',
          okButtonText: 'Login'
          // variant: 'my-confirm',
          // ...More props
        }).then((result) => {
          if (result.isOk) {
            window.location = '/login'
          }
        })

      }
    },
    cartAdd () {

      if (this.item.groups.length > 0 && !this.selectedGroup) {
        return
      }

      let item = this.item
      item = {
        ...item,
        quantity: this.quantity,
        option: this.selectedGroup,
        stock: this.item.type === 'recursive' ? this.selectedGroup.stock : 1,
        price: this.item.type === 'recursive' ? this.selectedGroup.price: this.item.price,
        sku: this.item.type === 'recursive' ? this.item.id + '_' + this.selectedGroup.id : this.item.id
      }

      this.$store.dispatch('cart/addToCart', item).then(() => {
      //  console.log('ok')
      }).catch(err => {
      //  console.log(err)
      })

      /*
      this.$notify({
        type: 'primary',
        showMethod: 'fade in right',
        message: item.name + ' added to cart'
      })
      */
    }
  }

}
</script>
